'use strict';

define('vb/extensions/dynamic/private/models/metadataRulesExtension',[
  'vb/extensions/dynamic/private/models/layoutResourceExtension',
], (
  LayoutResourceExtension,
) => {
  /**
   * MetadataRulesExtension is a subclass of LayoutResourceExtension used to load metadata-rules-x related resources,
   * which have special Translation Bundles semantics (v1 bundle definitions are preferred over v2 bundle definitions).
   */
  class MetadataRulesExtension extends LayoutResourceExtension {
    /**
     * MetadataRulesExtension constructor
     *
     * @param extension the extension from which to load the resource
     * @param {String} path the absolute path to the layout resource, e.g., vb/extA/dynamicLayouts/self/employee
     * @param base the base layout resource
     * @param className the class name
     */
    constructor(extension, path, base, className = 'MetadataRulesExtension') {
      super(extension, path, base, className);
    }

    static get extensionClass() {
      return MetadataRulesExtension;
    }

    /**
     * Overrides the base impl, so we can add "preferV1: true"
     * (v1 bundle definitions are preferred over v2 bundle definitions)
     *
     * @returns {Promise}
     */
    loadTranslationBundles() {
      // If V1 translations config is present, ignore V2 translations config.
      return super.loadTranslationBundles({ preferV1: true });
    }

    /**
     * V2 translations bundle resource name represented by '$default' bundle.
     *
     * Overrides the base impl to prefix the default bundle resource name with the extension id to ensure
     * name uniqueness for net-new default translation resources.
     *
     * @type {string}
     */
    get defaultBundleResourceName() {
      // Use the base's descriptor's defaultBundleResourceName, because the defaultBundleResourceName from the base
      // MetadataRules may aleady have prefixed its own extension's Id.
      const defaultBundleResourceName = this.base.resourceDescriptor.defaultBundleResourceName;
      // We must prepend the extension id and '__'.
      return `${this.extensionId}__${defaultBundleResourceName}`;
    }
  }

  return MetadataRulesExtension;
});

